module.exports = __webpack_public_path__ + "assets/b58.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b58.png
// module id = 647
// module chunks = 0